<template>
  <v-navigation-drawer app class="sidebar" v-model="drawer">
    <div class="box-sidebar-logo mb-2 elevation-1">
      <img class="logo-img" src="@/assets/logonova.png" alt="" />
      <h3 class="text-logo">{{ $t('system.system_abreviation')}}</h3>
      <small class="text-subtitle">{{ $t('system.system_name')}}</small> 
    </div>

    <div class="box-sidebar-logo mb-5 elevation-1">
      <h3 class="text-profile">{{ currentUser.profile }}</h3>
      <h4 class="text-unity" v-if="!isADM">
        {{ currentUser.unity_hospital }} - {{ currentUser.unity_cnes }}
      </h4> 
    </div>

    <div class="card-menu elevation-1" width="200">
      <v-list expand>
        <h6 class="text-section-menu">{{ $t('sidebar_titles.menu') }}</h6>
        <v-list-item-group class="list-group">
          <router-link to="/dashboard" class="link" active-class="link-ativo">
            <v-icon size="22" class="icon">mdi-finance</v-icon>
            <span>{{ $t('sidebar_titles.dashboard') }}</span>
          </router-link>

          <v-list-group class="list-group" v-if="abilityMixin.canAccess('cad_user')">
            <template v-slot:activator>
              <v-icon size="20" color="#086318" class="mr-1">mdi-plus-circle</v-icon>
              <span>{{ $t('sidebar_titles.basic_registrations') }}</span>
            </template>

            <router-link to="/usuarios" class="link ml-2 mr-2" active-class="link-ativo">
              <span>{{ $t('sidebar_titles.users') }}</span>
            </router-link>

            <router-link to="/perfis" class="link ml-2 mr-2" active-class="link-ativo" v-if="isADM">
              <span>{{ $t('sidebar_titles.profiles') }}</span>
            </router-link>

            <router-link to="/unidades" class="link ml-2 mr-2" active-class="link-ativo">
              <span>{{ $t('sidebar_titles.health_unities') }}</span>
            </router-link>

            <router-link to="/unidades-captadoras" class="link ml-2 mr-2" active-class="link-ativo">
              <span>{{ $t('sidebar_titles.captation_unities') }}</span>
            </router-link>

            <router-link to="/medico-profissional" class="link ml-2 mr-2" active-class="link-ativo">
              <span>{{ $t('sidebar_titles.professional_doctos') }}</span>
            </router-link>

            <router-link to="/orgaos-e-tecidos" class="link ml-2 mr-2" active-class="link-ativo">
              <span>{{ $t('sidebar_titles.orgons') }}</span>
            </router-link>

            <router-link to="/parentescos" class="link ml-2 mr-2" active-class="link-ativo">
              <span>{{ $t('sidebar_titles.kinship') }}</span>
            </router-link>

            <router-link to="/tipo-anexos" class="link ml-2 mr-2" active-class="link-ativo">
              <span>{{ $t('sidebar_titles.attachments_types') }}</span>
            </router-link>

            <v-list-group class="list-group">
              <template v-slot:activator>
                <span>{{ $t('sidebar_titles.reasons') }}</span>
              </template>

              <router-link to="/motivos-recusa-familiar" class="link ml-2 mr-2" active-class="link-ativo">
                <span>{{ $t('sidebar_titles.family_denied_reasons') }}</span>
              </router-link>

              <router-link to="/motivos-nao-realizacao-entrevista-familiar" class="link ml-2 mr-2"
                active-class="link-ativo">
                <span>{{ $t('sidebar_titles.no_interview_reasons') }}</span>
              </router-link>

              <router-link to="/motivos-nao-validacao" class="link ml-2 mr-2" active-class="link-ativo">
                <span>{{ $t('sidebar_titles.no_validation_reasons') }}</span>
              </router-link>

              <router-link to="/motivos-nao-captacao" class="link ml-2 mr-2" active-class="link-ativo">
                <span>{{ $t('sidebar_titles.no_captation_reasons') }}</span>
              </router-link>

              <router-link to="/causas-morte" class="link ml-2 mr-2" active-class="link-ativo">
                <span>{{ $t('sidebar_titles.brain_death_reasons') }}</span>
              </router-link>

              <router-link to="/causas-morte-pcr" class="link ml-2 mr-2" active-class="link-ativo">
                <span>{{ $t('sidebar_titles.pcr_death_reasons') }}</span>
              </router-link>
            </v-list-group>

            <v-list-group class="list-group">
              <template v-slot:activator>
                <span>{{ $t('sidebar_titles.diagnosis_and_comorbidities') }}</span>
              </template>

              <router-link to="/comorbidades" class="link ml-2 mr-2" active-class="link-ativo">
                <span>{{ $t('sidebar_titles.comorbidities') }}</span>
              </router-link>

              <router-link to="/diagnosticos-iniciais" class="link ml-2 mr-2" active-class="link-ativo">
                <span>{{ $t('sidebar_titles.initial_diagnosis') }}</span>
              </router-link>
            </v-list-group>
          </v-list-group>
        </v-list-item-group>

        <v-list-group class="" v-if="abilityMixin.canAccess('list_donor')">
          <template v-slot:activator>
            <v-icon size="24" color="#086318" class="mr-1">mdi-account-search</v-icon>
            <span>{{ $t('sidebar_titles.patients') }}</span>
          </template>

          <router-link to="/pacientes" class="link ml-2 mr-2" active-class="link-ativo" v-if="!hemobaProfiles">
            <span>{{ $t('sidebar_titles.follow_up_patients') }}</span>
          </router-link>

          <v-list-group class="list-group" v-if="abilityMixin.canAccess('cad_blood_group')">
            <template v-slot:activator>
              <small>{{ $t('sidebar_titles.immunohematology') }}</small>
            </template>

            <router-link to="/grupo-sanguineo" class="link ml-2 mr-2" v-if="abilityMixin.canAccess('cad_blood_group')">
              <v-icon size="22" class="icon">mdi-water</v-icon>
              <span>{{ $t('sidebar_titles.consults_blood_groups') }}</span>
            </router-link> 
          </v-list-group>

          <v-list-group class="list-group" v-if="abilityMixin.canAccess('cad_serology', 'cad_serology_nat')">
            <template v-slot:activator>
              <span>{{ $t('sidebar_titles.serology') }}</span>
            </template>
 
            <router-link to="/sorologia" class="link ml-2 mr-2" v-if="abilityMixin.canAccess('cad_serology') && !isHemobaNat">
              <v-icon size="22" class="icon">mdi-test-tube</v-icon>
              <span>{{ $t('sidebar_titles.consults_serology') }}</span>
            </router-link>

            <router-link to="/sorologia-nat" class="link ml-2 mr-2" v-if="abilityMixin.canAccess('cad_serology') && (isHemobaNat || isADM)">
              <v-icon size="22" class="icon">mdi-test-tube</v-icon>
              <span>{{ $t('sidebar_titles.consults_nat_serology') }}</span>
            </router-link>
          </v-list-group>
        </v-list-group>

        <router-link to="/logs" class="link" active-class="link-ativo" v-if="abilityMixin.canAccess('history_logs')">
          <v-icon size="22" class="icon">mdi-file-document</v-icon>
          <span>{{ $t('sidebar_titles.logs') }}</span>
        </router-link>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { profileSlug } from "@/helpers/profileSlug";
import { AbilityMixin } from "@/mixins/ability.mixin"; 
export default {
  mixins: [AbilityMixin],

  data() {
    return {
      drawer: null
    };
  },

  computed: {
    currentUser() {
      return this.getCurrentSession;
    },

    abilities() {
      return this.currentUser.abilities || [];
    },

    profile_slug() {
      return profileSlug(this.currentUser.profile);
    },

    isADM() {
      return ["admin"].includes(this.profile_slug);
    },

    isHemobaNat() {
      return ["tec_hemoba_nat"].includes(this.profile_slug);
    },

    hemobaProfiles() {
      return [
        "tec_hemoba_imuno",
        "tec_hemoba_sorologia",
        "tec_hemoba_nat",
        "gestor_hemoba",
      ].includes(this.profile_slug);
    },

    hemobaMenuTitle(){
      return ['tec_hemoba_imuno'].includes(this.profile_slug) ? 'Imunohematologias' : 'Sorologias'
    }
  },

  props: {
    resource: {
      type: Boolean,
    },
  },

  watch: {
    resource() {
      this.drawer = !this.drawer;
    },
  }
};
</script>

<style>
.text-subtitle {
  color: #086318 !important;
}

.v-navigation-drawer__border {
  width: 0px !important;
}

.sidebar {
  background: rgba(190, 223, 197, 0) !important;
  padding: 20px;
}

.box-sidebar-logo {
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;

  background: #ffffff;
  border-top: 4px solid #0e511a;
  border-radius: 8px;
  padding: 10px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.box-sidebar-logo:hover {
  box-shadow: 0 8px 16px rgba(14, 81, 26, 0.12);
  transform: translateY(-2px);
}

.logo-img {
  height: 110px;
  width: 245px;
  margin-bottom: 2px;
}

.text-logo {
  font-size: 20px;
  font-weight: 700;
  color: #086318;
  margin: 0;
}

.text-profile {
  font-size: 15px;
  font-weight: 500;
  color: #086318;
  margin: 0;
}

.text-unity {
  font-size: 12px;
  font-weight: 500;
  color: #086318;
  margin: 0;
}

.text-system-name {
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  color: #115726;
}

.card-menu {
  padding: 10px;
  background: #ffffff;
  border-top: 4px solid #0e511a;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(14, 81, 26, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.card-menu:hover {
  box-shadow: 0 4px 12px rgba(14, 81, 26, 0.12);
}

.text-section-menu {
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #000000;
  margin-bottom: 5px;
}

.list-group {
  display: flex;
  flex-direction: column;
} 

span, small {
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #000000;
} 
.link {
  padding: 10px;
  margin: 5px;
  text-decoration: none;
  display: flex;
  align-items: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-left: 4px solid transparent;
  position: relative;
}

.link:hover {
  background: #dff7e4;
  border-radius: 10px;
  border-left-color: #0e511a;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.link>.icon {
  margin-right: 5px;
  color: #086318 !important;
}

icon {
  margin-right: 10px;
  color: #e62c2c !important;
}

.link>span {
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #000000;
}

.link-ativo {
  background: #daf5e0;
  border: 1px solid #84b87f;
  border-left: 4px solid #0e511a;
  border-radius: 10px;
  color: red;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Mobile */
.v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close) {
  box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 0%) !important;
  background: rgb(248, 248, 248) !important;
}
</style>
